var isObject = require('./$.is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/core-js/library/modules/$.an-object.js
// module id = 1155
// module chunks = 0 1